export const getGridTemplateColumns = ({ headers = [], columns = [] }) => {
	return columns.length ? columns.join(' ') : `repeat(${headers.length}, 1fr)`
}

export const pairHeaders = (headers, size = 2) => {
	return headers.reduce((acc, _, i) => i % size ? acc : [...acc, headers.slice(i, i + size)], [])
}
